<div class="dialog" fxLayout="column" fxLayoutGap="15px">
  <div class="text">
    Bitte gib deine neue E-Mail Adresse an und nach einer kurzen Prüfung durch uns wird sie übernommen.
  </div>

  <!-- email input -->
  <div fxLayout="row" fxLayoutAlign="center center">
    <form [formGroup]="form">
      <div fxLayout="column" fxLayoutAlign="center center">
        <mat-form-field>
          <input matInput type="text" placeholder="E-mail Adresse" formControlName="email" />
        </mat-form-field>

        <mat-error *ngIf="form.controls.email.touched && form.controls.email.errors">
          <div *ngIf="form.controls.email.errors">{{ messages.emailInvalid }}</div>
        </mat-error>
      </div>
    </form>
  </div>

  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="20px" fxLayoutAlign="center center">
    <button class="orange-button" (click)="submitButtonClick()">Senden</button>
  </div>
</div>
